module.exports = __webpack_public_path__ + "img/performance-2.2dd33e84.png";